module.exports = __webpack_public_path__ + "img/syzxp01.0d884582.png";